import styled from 'styled-components';
import PhoneInput from './PhoneInput';
import { colorSchema } from 'utils/style';

export default styled(PhoneInput)`
  .phone-input {
    height: 48px;
    position: relative;

    &__phone-label {
      font-size: 1.2rem;
      color: ${colorSchema('greyGorilla')};
      pointer-events: none;
      position: absolute;
      display: inline-flex;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 5;
      height: 100%;
      padding: 0.8rem 0.8rem 0.8rem 4.5rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      transition: all 0.2s;

      &--filled {
        transform: translate(0, -20%);
      }
    }

    &__phone {
      height: 100%;
      border: ${props =>
        props.error
          ? `1px solid ${props.theme.base.colorSchema.redCherry}`
          : '0'};
      z-index: 4;

      input {
        background: ${props =>
          props.error ? colorSchema('redWattermelon') : colorSchema('white')};
        border-radius: 0;
        height: 100%;
        padding-top: 1.6rem;
        padding-right: 0.8rem;
        padding-bottom: 0.2rem;
        width: 100%;

        &:focus {
          .phone-input__phone-label {
            font-size: 1rem;
            transform: translate(94%, -24%);
          }
        }
      }
    }

    &__phone-button {
      border-radius: 0;
      height: 100%;
    }

    &__phone-dropdown.country-list {
      input {
        border-radius: 0;
        height: 38px;
        width: 93%;
      }
    }
  }
`;
